/**
 * Created by noOne on 14/02/2018.
 */

"use strict";

/**
 * @class
 */
export default class Test extends P3.Scene {
    constructor() {
        super();

        this._bgHolder = new PIXI.Container();
        this._holder = new PIXI.Container();
        this._uiHolder = new PIXI.Container();

        this._model = null;

        this._panels = [];

        this._isOrbiting = false;

        this._isFreeCam = true;

        this._proj = new P3D.Projection(this._holder, Common.renderer);
        this._camera = this._proj.camera;

    }

    init() {

        this.addChild(this._bgHolder, this._holder, this._uiHolder);

        //adjust light direction
        this._proj.lightDirection.y = 90;
        this._proj.lightDirection.z = 35;

        const a = P3.assets;

        //use a sprite to recolour background a sky blue colour
        const sprite = P3.utils.sprite(PIXI.Texture.WHITE, this._bgHolder, new PIXI.Point(0.5, 0.5));
        sprite.x = Common.STAGE_WIDTH * 0.5;
        sprite.y = Common.STAGE_HEIGHT * 0.5;
        sprite.width = Common.STAGE_WIDTH;
        sprite.height = Common.STAGE_HEIGHT;
        sprite.tint = 0x7EC0EE;

        this._bgSprite = sprite;

        let floor = new P3D.Plane(a.texture("default"));
        floor.scale.set(4, 1, 4);
        this._proj.addChild(floor);

        floor.y = -2;
        floor.z = -4;

        let backWall = new P3D.Plane(a.texture("default"));
        backWall.scale.set(4, 1, 4);
        this._proj.addChild(backWall);

        backWall.y = 0.5;
        backWall.z = -6.5;
        backWall.rotX = 90;

        const sp = new PIXI.Sprite(PIXI.Texture.WHITE);
        sp.tint = 0xff0000;

        const tex = Common.renderer.generateTexture(sp);

        let cube = new P3D.Cube(tex);
        cube.scale.set(0.1);

        floor.addChild(cube);

        cube.y = 0.5;

        const container = new P3D.Container();
        this._proj.addChild(container);

        container.y = -1.35;

        container.x = floor.x;
        container.z = floor.z;

        const config = P3.assets.json("emitter");
        console.log(config);

        let emitter = new P3D.Emitter(container, config, P3.assets.texture);

        this.emitter = emitter;

        emitter.emit = true;
    }


    update() {

        this.emitter.update(deltaTime);

        this._proj.update();

        this._freeCam();

    }

    _freeCam() {

        //handle keyboard input
        const rotSpeed = 120;
        if (P3.input.isKeyDown(65)) {    //rot left
            this._camera.rotation.y += rotSpeed * deltaTime;
        } else if (P3.input.isKeyDown(68)) {    //rot right
            this._camera.rotation.y -= rotSpeed * deltaTime;
        }

        let speed = 0;
        if (P3.input.isKeyDown(87)) {    //forward
            speed = 16;
        } else if (P3.input.isKeyDown(83)) {    //back
            speed = -16;
        }

        this._camera.x -= Math.sin(glMatrix.toRadian(this._camera.rotation.y)) * speed * deltaTime;
        this._camera.z -= Math.cos(glMatrix.toRadian(this._camera.rotation.y)) * speed * deltaTime;

        let riseSpeed = 0;
        if (P3.input.isKeyDown(90)) {    //up
            riseSpeed = 20;
        } else if (P3.input.isKeyDown(88)) {    //down
            riseSpeed = -20;
        }

        if (P3.input.isKeyDown(38)) {    //forward
            this._camera.rotation.x -= 8 * deltaTime;
        } else if (P3.input.isKeyDown(40)) {    //back
            this._camera.rotation.x += 8 * deltaTime;
        }

        this._camera.y += riseSpeed * deltaTime;

        if (P3.input.isKeyPressed(32)) {//log pos and rot on spacebar down
            // console.log("pos", this._camera.position);
            //  console.log("rot", this._camera.rotation);
            console.log(this.emitter.countAlive());
        }

    }

    destroy() {
        super.destroy({children: true});
        TweenMax.killAll();
    }

    appear() {
        super.appear();
    }

    end() {
        this.signals.next.dispatch(this);
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
    }
}

